module.exports = __webpack_public_path__ + "static/media/m1-POSTURE.d424e6c3.png";